<template lang="pug">
modal(:max-width="400")
	.card(style="text-align:left;")
		.card-header.bg-info.text-white
			span.fa.fa-tag.mr-2
			| Gestión de etiquetas
			button.close(@click="cerrar") &times;
		.card-body
			.form-group
				label Busca una etiqueta
				input-query(inputClass="form-control", :realtime="true", url="galerias/php/api/query-personas.php", @selected="seleccionada($event)")
		.card-body.bg-light(v-if="persona")
			.form-group
				label Nombre
				input.form-control(v-model="persona.Nombre", placeholder="Nombre")
		.card-footer(v-if="persona")
			.row
				.col.text-left
					button.btn.btn-primary.btn-sm(@click="guardar")
						span.fa.fa-save.mr-2
						| Guardar
				.col.text-right
					button.btn.btn-danger.btn-sm(@click="eliminar")
						span.fa.fa-trash.mr-2
						| Eliminar
</template>

<script>
export default {
	data () {
		return {
			persona: null
		}
	},
	methods: {
		seleccionada (ev) {
			this.persona = ev.data
		},
		guardar () {
			if (!this.persona.Nombre) {
				this.$error('Debes escribir un nombre')
				return
			}

			this.$http.post('galerias/php/api/set-persona.php', this.persona)
				.then(res => {
					this.$store.commit('toast/success', {
						titulo: 'Etiqueta guardada'
					})
				})
				.catch(e => {
					this.$error(e.response.data.error)
				})
		},
		eliminar () {
			// Buscamos las fotos asociadas
			this.$http.get('galerias/php/api/get-numero-de-fotos-persona.php?PersonaID=' + this.persona.PersonaID)
				.then(res => {
					if (res.data.items > 0) {
						this.$store.commit('alertas/confirm', {
							titulo: 'Atención',
							mensaje: `Esta etiqueta está asociada a ${res.data.items} items.
							
							Si la eliminas se eliminarán también las asociaciones`,
							callback: acepta => {
								this.confirmaEliminacion()
							}
						})
					} else {
						this.confirmaEliminacion()
					}
				})
		},
		confirmaEliminacion () {
			this.$http.post('galerias/php/api/del-persona.php', {PersonaID: this.persona.PersonaID})
				.then(res => {
					this.persona = null
					this.$store.commit('toast/success', {
						titulo: 'Etiqueta eliminada'
					})
				})
				.catch(e => {
					this.$error(e.response.data.error)
				})
		},
		cerrar () {
			this.$emit('cerrar')
		}
	}
}
</script>




// WEBPACK FOOTER //
// src/modulos/galerias/vue/componentes/gestion-etiquetas/gestion-etiquetas.vue